import { $t } from '@/i18n';
import wujiFetch from '@utils/wujiFetch';
import { BASE_API_PATH, getRuntimeEnvPath } from '@config/constant';

const designBaseUrl = `${BASE_API_PATH}/xy/design/announcement`;
const runtimeBaseUrl = `${BASE_API_PATH}/xy/runtime/announcement`;
const getManageBaseUrl = ({ runtime = false, env } = {}) => (runtime
  ? `${getRuntimeEnvPath(env)}/announcement/manage`
  : designBaseUrl);

const fetchManagement = async (url, options, runtime = false) => {
  const result = await wujiFetch(url, options);
  // 登录过期时 wujiFetch 会打开登录窗口并返回空值，不能将它提交到公告管理状态。
  if (runtime && (result === undefined || result === null)) {
    throw new Error($t('k_2c1ef7dc'));
  }
  return result;
};

const fetchAnncmntList = async (projectId, filter = '', context = {}) => await fetchManagement(
  `${getManageBaseUrl(context)}?projectid=${projectId}&filter=${encodeURIComponent(filter)}`
  , {
    method: 'GET',
    timeout: 3000,
  },
  context.runtime,
);

const deleteAnncmnt = async ({ projectId, id, headers = {}, ...context }) => await fetchManagement(
  `${getManageBaseUrl(context)}/${id}?projectid=${projectId}`,
  {
    method: 'DELETE',
    headers,
  },
  context.runtime,
);

const updateAnncmnt = async ({ projectId, id, data = {}, headers = {}, ...context }) => await fetchManagement(
  `${getManageBaseUrl(context)}/${id}?projectid=${projectId}`,
  {
    method: 'PATCH',
    body: JSON.stringify(data),
    headers,
  },
  context.runtime,
);

const createAnncmnt = async ({ projectId, data = {}, headers = {}, ...context }) => await fetchManagement(
  `${getManageBaseUrl(context)}?projectid=${projectId}`,
  {
    method: 'POST',
    body: JSON.stringify({
      ...data,
      projectId,
    }),
    headers,
  },
  context.runtime,
);

const fetchAnncmntSetting = async (projectId, env) => await fetchManagement(
  `${getManageBaseUrl({ runtime: true, env })}/setting?projectid=${projectId}`,
  { method: 'GET' },
  true,
);

const fetchAnncmntCapabilities = async (projectId, env) => await fetchManagement(
  `${getManageBaseUrl({ runtime: true, env })}/capabilities?projectid=${projectId}`,
  { method: 'GET' },
  true,
);

const updateAnncmntSetting = async ({ projectId, env, data }) => await fetchManagement(
  `${getManageBaseUrl({ runtime: true, env })}/setting?projectid=${projectId}`,
  { method: 'PATCH', body: JSON.stringify(data) },
  true,
);

const fetchAnncmntRuntimeList = async (projectId, filter = '') => await wujiFetch(
  `${runtimeBaseUrl}?projectid=${projectId}&filter=${encodeURIComponent(filter)}`,
  {
    method: 'GET',
    timeout: 3000,
  },
);

const fetchAnncmnLoopList = async projectId => await wujiFetch(
  `${runtimeBaseUrl}?projectid=${projectId}&filter=${encodeURIComponent('style=\'carousel\'')}`,
  {
    method: 'GET',
    timeout: 3000,
  },
);

const readAnncmntRuntime = async (projectId, id, endTime) => await wujiFetch(
  `${runtimeBaseUrl}/read/${id}?projectid=${projectId}`,
  {
    method: 'POST',
    body: JSON.stringify({
      endTime,
    }),
  },
);

export default {
  fetchAnncmntList,
  deleteAnncmnt,
  updateAnncmnt,
  createAnncmnt,
  fetchAnncmntSetting,
  fetchAnncmntCapabilities,
  updateAnncmntSetting,
  fetchAnncmntRuntimeList,
  fetchAnncmnLoopList,
  readAnncmntRuntime,
};
